import(/* webpackMode: "eager", webpackExports: ["MarketingFooter"] */ "/vercel/path0/apps/web/components/marketing/MarketingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingHeader"] */ "/vercel/path0/apps/web/components/marketing/MarketingHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PressDocumentLang"] */ "/vercel/path0/apps/web/components/marketing/PressDocumentLang.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
